<template>
	<q-layout-header :reveal="reveal" :reveal-offset="20">
		<q-toolbar :inverted="$q.theme === 'ios'">
			<!--<q-btn flat round dense icon="menu" @click="left = !left" aria-label="Toggle menu on left side" />-->
			<q-toolbar-title class="widget-title">
				Will My Credits Transfer?
				<span slot="subtitle">{{ clientInstitutionName }}</span>
			</q-toolbar-title>

			<slot name="toolbar-buttons">
			</slot>
		</q-toolbar>

		<slot name="tabs"></slot>
	</q-layout-header>
</template>

<script lang="ts">
import { Vue, Component } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

@Component({
	computed: mapGetters('wmct', [
		'clientInstitutionName',
		'isEditingAny',
	]),
})
export default class LayoutHeader extends Vue {
	private clientInstitutionName!: string;
	private isEditingAny!: boolean;

	private get reveal() {
		return !this.isEditingAny;
		// const quasar: any = (this as any).$q;

		// return !(quasar.platform.has.touch && this.isEditingAny);
	}
}
</script>

<style>
	@media screen and (max-width: 373px) {
		.q-toolbar-title.widget-title {
			font-size: .9rem;
			white-space: initial;
		}
	}
</style>